var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1 14.76h-.798c-1.085 0-1.981-1.01-1.981-2.273v-.314c.815-.507 1.39-1.475 1.39-2.588V5.978C15.71 4.32 14.54 3 13.062 3h-2.126C9.46 3 8.29 4.319 8.29 5.978v3.607c0 1.113.572 2.079 1.386 2.588v.314c0 1.264-.895 2.273-2.021 2.273h-.753c-1.281 0-2.356.821-2.902 2.054 1.865 2.51 4.602 4.08 7.71 4.186h.578c3.108-.105 5.844-1.676 7.712-4.186-.545-1.233-1.62-2.054-2.9-2.054z","stroke":"#5B00DB","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

User.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = User;

User.default = User;
